import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Основной контент футера */}
        <div className="footer-main">
          {/* Левая колонка - Логотип и контакты */}
          <div className="footer-left">
            <div className="footer-logo">
              <img loading="lazy"
                src="/images/logo_main_white.webp"
                alt="1SELLER × Яндекс KIT"
                className="footer-logo-image"
              />
            </div>
            <div className="footer-contacts">
              <a href="tel:+74991105752" className="footer-phone">
                +7 (499) 110-57-52
              </a>
              <a href="mailto:info@1seller.ru" className="footer-email">
                info@1seller.ru
              </a>
              <a href="https://t.me/shema" target="_blank" rel="noopener noreferrer" className="footer-telegram">
                Telegram: @shema
              </a>
              <p className="footer-location">г. Екатеринбург, ул. Малышева, стр. 51, этаж 23</p>
            </div>
          </div>

          {/* Правая колонка - Документы */}
          <div className="footer-right">
            <h3 className="footer-title">Документы</h3>
            <ul className="footer-links">
              <li>
                <a href="/privacy-policy" className="footer-link">
                  Политика конфиденциальности
                </a>
              </li>
              <li>
                <a href="/" className="footer-link">
                  1seller.ru
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Реквизиты */}
        <div className="footer-requisites">
          <p>
            ООО «Первый Селлер» · ИНН 7100015148 · ОГРН 1217100015021 · КПП 668501001<br />
            620000, Свердловская область, г. Екатеринбург, ул. Малышева, стр. 51, этаж 23, помещ. 19
          </p>
        </div>

        {/* Дисклеймер */}
        <div className="footer-disclaimer">
          <p>
            Информация, представленная на сайте, носит информационный характер и не является публичной офертой
            в соответствии со статьёй 437 Гражданского кодекса Российской Федерации. Показанные результаты являются
            иллюстративными и могут отличаться в зависимости от индивидуальных условий вашего бизнеса.
          </p>
        </div>

        {/* Копирайт */}
        <div className="footer-copyright">
          <p>© 2020–2026 ООО «Первый Селлер». Екатеринбург. Все права защищены.</p>
        </div>
      </div>

      <style>
        {`
          .footer {
            background: #0F0F1A;
            padding: 60px 0 30px;
            color: rgba(255, 255, 255, 0.7);
            font-family: 'Inter', sans-serif;
          }

          .footer-container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 24px;
          }

          .footer-main {
            display: grid;
            grid-template-columns: 2fr 1fr;
            gap: 60px;
            margin-bottom: 50px;
            padding-bottom: 50px;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          }

          .footer-left {
            display: flex;
            flex-direction: column;
            gap: 24px;
          }

          .footer-logo {
            display: flex;
            align-items: center;
            margin-bottom: 8px;
          }

          .footer-logo-image {
            height: 32px;
            width: auto;
            transition: opacity 0.3s ease;
          }

          .footer-logo-image:hover {
            opacity: 0.8;
          }

          .footer-contacts {
            display: flex;
            flex-direction: column;
            gap: 12px;
          }

          .footer-phone {
            color: #FFFFFF;
            text-decoration: none;
            font-size: 18px;
            font-weight: 600;
            transition: color 0.3s ease;
          }

          .footer-phone:hover {
            color: #FF8847;
          }

          .footer-email,
          .footer-telegram {
            color: rgba(255, 255, 255, 0.8);
            text-decoration: none;
            font-size: 16px;
            font-weight: 500;
            transition: color 0.3s ease;
          }

          .footer-email:hover,
          .footer-telegram:hover {
            color: #FF8847;
          }

          .footer-location {
            color: rgba(255, 255, 255, 0.5);
            font-size: 14px;
            font-weight: 400;
            margin: 0;
          }

          .footer-right {
            display: flex;
            flex-direction: column;
            gap: 16px;
          }

          .footer-title {
            font-size: 16px;
            font-weight: 700;
            color: #FFFFFF;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            margin: 0 0 8px 0;
          }

          .footer-links {
            list-style: none;
            padding: 0;
            margin: 0;
            display: flex;
            flex-direction: column;
            gap: 12px;
          }

          .footer-link {
            color: rgba(255, 255, 255, 0.7);
            text-decoration: none;
            font-size: 15px;
            font-weight: 400;
            transition: color 0.3s ease;
          }

          .footer-link:hover {
            color: #FF8847;
          }

          .footer-requisites {
            margin-bottom: 30px;
            padding-bottom: 30px;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          }

          .footer-requisites p {
            font-size: 13px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.4);
            line-height: 1.6;
            margin: 0;
          }

          .footer-disclaimer {
            margin-bottom: 30px;
            padding-bottom: 30px;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          }

          .footer-disclaimer p {
            font-size: 13px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.4);
            line-height: 1.6;
            margin: 0;
          }

          .footer-copyright {
            text-align: center;
          }

          .footer-copyright p {
            font-size: 14px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.5);
            margin: 0;
          }

          @media (max-width: 768px) {
            .footer {
              padding: 40px 0 20px;
            }

            .footer-main {
              grid-template-columns: 1fr;
              gap: 40px;
              margin-bottom: 40px;
              padding-bottom: 40px;
            }

            .footer-logo-image {
              height: 28px;
            }
          }
        `}
      </style>
    </footer>
  );
};

export default Footer;
